import {
	Contact,
	UserAddLoginDocument as ADD_USER_LOGIN,
	UserChangeGroupsDocument as USER_CHANGE_GROUPS,
	UserRemoveLoginDocument as USER_REMOVE_LOGIN,
	UserSetEnabledDocument as USER_SET_ENABLED,
	User,
} from "@repo/server-api";
import { EmailInformation } from "@repo/server-api/types";

import { useMutationWithPromise } from "../helper/Index";

export const useCreateUserLogin = () => {
	const addUserLogin = useMutationWithPromise(ADD_USER_LOGIN);

	const doWork = async (
		contact: Contact | null,
		user: User | null,
		sendVerificationEmail: boolean,
	) => {
		return addUserLogin({
			contactId: contact ? contact.id : user?.contactId,
			email:
				contact?.additionalInformation.filter(
					(a): a is EmailInformation => (a as EmailInformation).__typename === "EmailInformation",
				)[0]?.emailAddress ?? user?.email,
			firstName: contact?.firstName ?? user?.firstName,
			groupIds: user?.groups.map((g) => g),
			lastName: contact?.lastName ?? user?.lastName,
			username: user?.username,
			clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
			redirectUri: window.location.origin,
			sendVerificationEmail: sendVerificationEmail,
		});
	};

	return [doWork];
};

export const useUpdateUserLogin = () => {
	const userChangeGroups = useMutationWithPromise(USER_CHANGE_GROUPS);
	const userSetEnabled = useMutationWithPromise(USER_SET_ENABLED);

	const doWork = async (user: User) => {
		return await Promise.all([
			userChangeGroups({
				groupIds: user.groups.map((g) => g),
				userId: user.id,
			}),
			userSetEnabled({
				enabled: user.enabled,
				userId: user.id,
			}),
		])
			.then((res) => {
				return res;
			})
			.catch((err) => {
				return err;
			});
	};

	return [doWork];
};

export const useDeleteUserLogin = () => {
	const userRemoveLogin = useMutationWithPromise(USER_REMOVE_LOGIN);

	const doWork = async (userId: string) => {
		return userRemoveLogin({
			userId: userId,
		});
	};

	return [doWork];
};
